import { CustomException, request } from '@tencent/ppd-base-libs';
import { defaultParams, QRY_DP_MSG_BY_DPID, requestConfigs } from '../config';
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { QryDpMsgByDpIdReq, QryDpMsgByDpIdRes } from '../types/index';
import { formatDpItem, handleFormatObj, TargetType } from '../utils/format';
import { isPassPreCheck } from '../utils/pre-check-params';
import { getCgiName, reportElk } from '../utils/report';

// eslint-disable-next-line @typescript-eslint/naming-convention
export const needParseIntKey = ['appid', 'dp_channel'];
const targetUrl = QRY_DP_MSG_BY_DPID;

/** 接口2 - 指定投放计划获取投放内容接口 */
export const queryDpMessageByDpId = async (qryParams: Omit<QryDpMsgByDpIdReq, 'appid' | 'dpChannel'>) => {
  const params = {
    ...defaultParams,
    ...qryParams,
  };
  const needCheckFields = ['appid', 'dpChannel', 'dpPage', 'uin', 'dpId'];
  if (!isPassPreCheck(params, needCheckFields)) {
    new CustomException(params, 'dpLoader-ParamsError', `${getCgiName(targetUrl)}接口参数缺失`);
    return;
  }

  // 这里是为了对使用方统一使用dpId（而不是dpid)
  const dpid = params.dpId;
  delete (params as any).dpId;

  let formattedParams = {};
  let returnResult = {};
  try {
    formattedParams = handleFormatObj({
      targetType: TargetType.line,
      target: {
        ...params,
        dpid,
      }, needParseIntKey,
    });
    const result = await request.post(targetUrl, formattedParams, requestConfigs);
    returnResult = handleFormatObj({
      targetType: TargetType.hump,
      target: result, transformer: (res) => {
        if (!res) {
          return res;
        }
        const dpList = res.dpList || [];
        return {
          ...res,
          dpList: dpList.map(item => formatDpItem(item)),
        };
      },
    });
    reportElk({ url: targetUrl, params: formattedParams, res: returnResult });
  } catch (e) {
    reportElk({ url: targetUrl, params: formattedParams, res: e as any });
    throw e;
  }
  console.log('====queryDpMsgById result', returnResult);
  return returnResult as QryDpMsgByDpIdRes;
};


